// @ts-expect-error Untyped
import RequestStatus from 'developer-docs-shared-components/lib/models/RequestStatus';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import { Link } from 'foundations-components/transitional/components/Link';
import styled from 'styled-components';
import { getAppHomeUrl, getLoginUrl } from '../utils/urls';
import { Flex } from 'foundations-components/components/Flex';
import { useSelector } from 'react-redux';
import { selectLoggedIn } from '../selectors/userState';
import { jsx as _jsx } from "react/jsx-runtime";
const LinkWrapper = styled.div.withConfig({
  displayName: "AccountLink__LinkWrapper",
  componentId: "sc-2erj64-0"
})(["font-size:", ";margin-left:1.8vw;", "{margin-left:48px;}"], ({
  theme
}) => theme.typography['body-125'].fontSize, mediaQueries.aboveWidth(1512));
const LinkContents = ({
  isLoggedIn
}) => {
  if (isLoggedIn) {
    return /*#__PURE__*/_jsx(Link, {
      href: getAppHomeUrl(),
      external: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.header.myAccount"
      })
    });
  }
  return /*#__PURE__*/_jsx(Link, {
    href: getLoginUrl(),
    external: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "developer-docs-ui.header.login"
    })
  });
};
export const AccountLink = ({
  isMobile
}) => {
  const loggedIn = useSelector(selectLoggedIn);
  const isLoggedIn = loggedIn.status === RequestStatus.succeeded && !!loggedIn.data;
  if (isMobile) {
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "end",
      children: /*#__PURE__*/_jsx(LinkContents, {
        isLoggedIn: isLoggedIn
      })
    });
  }
  return /*#__PURE__*/_jsx(LinkWrapper, {
    children: /*#__PURE__*/_jsx(LinkContents, {
      isLoggedIn: isLoggedIn
    })
  });
};